import { useMutation, useQueryClient } from '@tanstack/react-query';

import { Axios } from '@app/web-components';

import { subscriptionKeys } from './subscriptions';

const SUBSCRIPTION_ACCESS_ALL_QUERY_KEY = 'SUBSCRIPTION_ACCESS_ALL_QUERY_KEY';
const RESOURCE_URL = '/subscription-accesses';

export const subscriptionAccessKeys = {
  all: [SUBSCRIPTION_ACCESS_ALL_QUERY_KEY] as const,
  lists: () => [...subscriptionAccessKeys.all, 'list'] as const,
  list: (filters: object) => [...subscriptionAccessKeys.lists(), filters] as const,
};

export const useSubscriptionAccessTriggerRepush = () => {
  const axios = Axios.useAxiosApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: number) => axios.post(`${RESOURCE_URL}/trigger-repush`, { id }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [subscriptionAccessKeys.all, subscriptionKeys.all] });
    },
  });
};

export const useDeleteSubscriptionAccess = () => {
  const axios = Axios.useAxiosApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: number) => axios.delete(`${RESOURCE_URL}/${id}`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [subscriptionAccessKeys.all, subscriptionKeys.all] });
    },
  });
};
